import React, { useState, useEffect, useContext } from 'react'
// CONTEXT
import { AppContext } from './../App'
// FIREBASE
import { getDatabase, ref, query, limitToLast, onValue, equalTo, where, orderByChild } from "firebase/database"
import database from '../firebase/base'
import useFirebase from './../firebase/useFirebase'
import Spinner from '../components.js/elements/Spinner'
import { useNavigate } from 'react-router-dom'
// DATE
import addDays from 'date-fns/addDays'
import { format } from 'date-fns'
import fr from 'date-fns/locale/fr'

const Montest = () => {
    const { user } = useContext(AppContext)
    const [montage,setMontage] = useState(true)
    const [client, setClient] = useState([])
    const [tableau, setTableau] = useState([])
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const { readData, readDataMessagesChat, profil, count, messagesChat, clients, services, staff } = useFirebase()
    const [trierClientsEtNewMessages, setTrierClientsEtNewMessages] = useState([])

    useEffect(() => {
        setMontage(false)
        readData(keyUid)
    },[])

    if (montage) return <Spinner />


    const _testDisplay = () => {
        const array = []
        clients.map(cl => (
            array.push({ name:cl.name, surname:cl.surname,uid:cl.uid })
        ))
        return array
    }

    const _testFireabase = () => {
        const array = []
        const starCountRef = query(ref(database, 'entreprises/'+user.uid+'/messagesChat'), orderByChild("isNew"),  equalTo(true))
        try {
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                for (let id in data) {
                    array.push({id,...data[id]})
                }
            })
        } catch {
            alert('il y a une erreur dans la lecture')
        } 
        return array
    }

    const _quiPeuxRealiserLeService = (isStaff) => {
        const array = []
        const starCountRef = query(ref(database, 'entreprises/'+user.uid+'/staff'), orderByChild("isNew"),  equalTo(true))
    }

    const _displayHours = () => {
        const array = []
        for (let i = 0; i < 96; i++) {
            array.push(i)
        }
        return array
    }

    // DISPLAY 60 DAYS
    const _display60Days = () => {
        const array = []
        const m = 0

        for (let i = 0; i < 60; i++) {

            const addDay = addDays(new Date(Date.now()), i) 
            const day = format(new Date(addDay), 'EEEE', {locale:fr})
            const date = format(new Date(addDay), 'MM/dd/yyyy')
            const dateShow = format(new Date(addDay), 'EEEE dd MMMM', {locale:fr})

            array.push({ date:date, day:day, dateShow:dateShow })
        }

        return array 
    }

    // FILTER STAFF
    const _filterStaff = (day,h) => {
        const array = []
        // liste des éléments
        // service
        // staff corrspondant au service
        staff.map(st => (
            services.filter(ser => ser.id === '-Mxd3d0o9AOqsm73Ieyp' && ser[st.id] === true).map(ser => (





                array.push({ nameStaff:st.nameStaff, day:day, heure:h })
            ))
        ))
        // staff correspondant au service
        // pour chaque staff
            // hors jours de fermetures
            // dans les 4 semaines
            // horaires disponiblent
            // pas de réservations en cours

        return array
    }
 
    const _onChange = () => {
        console.log('Montest _onChange ')
    }

    return (
        <div className='container-fluid'> 

            <div className='michel'>page mon test</div>

            <button onClick={_onChange}>button</button>

            <div className='d-grid'>
                <button onClick={_onChange} type='button'  className='michel btn'>button</button>
            </div>
            

            <button onClick={_onChange} type='button' className='btn btn-dark'>mon test</button>



        </div>
    )
}

export default Montest

